module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero-banner scrolled-sec"
  }, [(_vm.props.acf.sitename) ? _c('h3', {
    staticClass: "heading",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.sitename)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "banner-slider"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption1
    }
  }, _vm._l((_vm.props.acf.bannerimage), function(bannerSlider, i) {
    return _c('swiper-slide', {
      key: bannerSlider.id,
      style: ({
        backgroundImage: 'url(' + bannerSlider.images + ')'
      })
    }, [_c('div', {
      staticClass: "slide-content-wrapper"
    }, [_c('div', {
      staticClass: "swiper-button-prev swiper-button-prev1",
      attrs: {
        "slot": "button-prev"
      },
      slot: "button-prev"
    }, [_c('div', {
      staticClass: "fa fa-angle-left"
    })]), _c('div', {
      staticClass: "swiper-button-next swiper-button-next1",
      attrs: {
        "slot": "button-next"
      },
      slot: "button-next"
    }, [_c('div', {
      staticClass: "fa fa-angle-right"
    })])])])
  }))], 1), _c('div', {
    staticClass: "section-action"
  }, [(_vm.props.acf.popupimage) ? _c('img', {
    staticClass: "modal-trigger",
    attrs: {
      "id": "readPopup",
      "src": _vm.props.acf.popupimage,
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.$bvModal.show('readPopup')
      }
    }
  }) : _vm._e(), (_vm.props.acf.popupcontent) ? _c('b-modal', {
    attrs: {
      "id": "readPopup",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.props.acf.popupheading
    }
  }, [_c('div', {
    staticClass: "simple-modal-content"
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.popupcontent)
    }
  })])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dd502e6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/hero.pug
// module id = 810
// module chunks = 1